const common = {
  siteName: '磁力网站大全',
  siteTagline: '最新磁力资源搜索平台',
  home: '首页',
  about: '关于我们',
  categories: '分类导航',
  viewAll: '查看全部',
  readMore: '了解更多',
  submit: '提交',
  contact: '联系我们',
  search: '搜索磁力网站...',
  searchBtn: '搜索',
  copyright: '版权所有',
  allRightsReserved: '保留所有权利',
  backToHome: '返回首页',
  pageNotFound: '页面未找到',
  pageNotFoundDesc: '您访问的页面不存在或已被移除',
  breadcrumbHome: '首页',
};

export default common;